import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getKey } from './dictionary';
import * as printf from 'sprintf-js';

class II18 extends Component {
  /**
   * Get translate
   *
   * @param {string} key
   * @param {[] | undefined} params
   * @param {boolean | undefined} html
   * @returns string | Element
   */
  static get(key, params = undefined, html = false) {
    const translate = printf.vsprintf(
      getKey(key, window.userLang),
      params instanceof Array ? params : params === undefined ? [''] : [params]
    );

    return html || II18.isHtml(translate) || II18.isKeyHtml(key) ? (
      <span dangerouslySetInnerHTML={{ __html: translate }} />
    ) : (
      translate
    );
  }

  static locale() {
    return II18.get('locale');
  }

  static dateFormat() {
    return II18.get('dateFormat');
  }

  static isHtml(text) {
    return text.indexOf('<b>') > -1 || text.indexOf('<i>') > -1;
  }

  static isKeyHtml(text) {
    return text.indexOf('_html') > -1;
  }

  static getHtml(key, params) {
    return II18.get(key, params, true);
  }

  static getAll(keys) {
    return keys.reduce((items, item) => {
      items.push(getKey(item, window.userLang));
      return items;
    }, []);
  }

  render() {
    return II18.get(
      this.props.get ? this.props.get : this.props.children,
      this.props.params,
      this.props.html
    );
  }
}

II18.propTypes = {
  get: PropTypes.string,
  children: PropTypes.string,
  params: PropTypes.any,
  html: PropTypes.bool
};
export default II18;
